import { Box, CardContent, CardHeader, Stack, TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";

interface ContactInfoProps {
  hasAttemptedValidation?: boolean;
  title?: string;
}

export default function ContactInfo({
  hasAttemptedValidation = false,
  title = "1. Please enter your contact info",
}: ContactInfoProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Box>
      <CardHeader slotProps={{ title: { variant: "h5" } }} title={title} />
      <CardContent>
        <Stack spacing={3}>
          <TextField
            label="First Name*"
            {...register("firstName", { required: "First name is required" })}
            error={hasAttemptedValidation && !!errors.firstName}
            helperText={
              hasAttemptedValidation && typeof errors.firstName?.message === "string"
                ? errors.firstName.message
                : ""
            }
            autoFocus
          />
          <TextField
            label="Last Name*"
            {...register("lastName", { required: "Last name is required" })}
            error={hasAttemptedValidation && !!errors.lastName}
            helperText={
              hasAttemptedValidation && typeof errors.lastName?.message === "string"
                ? errors.lastName.message
                : ""
            }
          />

          <TextField
            label="Organization Name"
            {...register("organizationName")}
            error={hasAttemptedValidation && !!errors.organizationName}
            helperText="No organization name? Just use your First and Last Name"
          />
          <TextField
            label="Email*"
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Please enter a valid email address",
              },
            })}
            error={hasAttemptedValidation && !!errors.email}
            helperText={
              hasAttemptedValidation && typeof errors.email?.message === "string"
                ? errors.email.message
                : ""
            }
          />
        </Stack>
      </CardContent>
    </Box>
  );
}
